import { GoExternal } from '@clearkit/icons';
import { CKBox, CKButton } from 'clearkit';

import PromotionalFeatureCallout from './PromotionalFeatureCallout';

export default function AccessGuardLayout({
  title,
  description,
  tile,
  featureCallouts,
  testimonial,
  onRequestAccess = () => {},
}) {
  return (
    <div className="flex flex-col w-full min-h-full">
      <div className="px-20 pt-20 border-b">
        <div className="pb-20">
          <div className="flex items-center w-full font-semibold">
            <div className="h-12 mr-3">{tile}</div>
            <h1 className="text-xl font-semibold">{title}</h1>
          </div>
          <div className="max-w-xl my-5 text-lg text-gray-900 leading-8">
            {description}
          </div>
          <CKButton
            onClick={() => onRequestAccess()}
            variant="bold"
            variantColor="blue"
          >
            Request access
          </CKButton>
        </div>
      </div>
      <div className="flex flex-grow">
        <div className="w-full px-16 py-10 bg-gray-50">
          <CKBox className="flex flex-row items-stretch">
            <div className="flex flex-col items-center justify-around bg-white border-r rounded rounded-r-none gap-10 min-w-64 p-14">
              {featureCallouts.map((feature) => (
                <PromotionalFeatureCallout
                  description={feature.description}
                  icon={feature.image}
                  key={feature.name}
                  name={feature.name}
                />
              ))}
            </div>
            <div className="flex flex-col items-center justify-center flex-grow px-20 py-24 rounded rounded-l-none bg-gray-0">
              <div className="max-w-md text-xl font-semibold text-center text-gray-800">
                &ldquo;{testimonial.quote}&rdquo;
              </div>
              <div className="pt-12 pb-10 text-center">
                <div className="text-xl font-semibold text-gray-800">
                  {testimonial.customerName}
                </div>
                <div className="text-base text-gray-500">
                  {testimonial.customerTitle}
                </div>
              </div>
              <CKButton
                as={'a'}
                href={testimonial.url}
                leftIcon={<GoExternal />}
              >
                Read their customer story
              </CKButton>
            </div>
          </CKBox>
        </div>
      </div>
    </div>
  );
}
